// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * XML fragment value.
 */
export class XmlElement implements flatbuffers.IUnpackableObject<XmlElementT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): XmlElement {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsXmlElement(bb: flatbuffers.ByteBuffer, obj?: XmlElement): XmlElement {
    return (obj || new XmlElement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsXmlElement(bb: flatbuffers.ByteBuffer, obj?: XmlElement): XmlElement {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new XmlElement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): string;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  value(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startXmlElement(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static endXmlElement(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // value
    return offset;
  }

  static createXmlElement(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    XmlElement.startXmlElement(builder);
    XmlElement.addValue(builder, valueOffset);
    return XmlElement.endXmlElement(builder);
  }

  unpack(): XmlElementT {
    return new XmlElementT(this.value());
  }

  unpackTo(_o: XmlElementT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): XmlElementT {
    const t = new XmlElementT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class XmlElementT implements flatbuffers.IGeneratedObject {
  constructor(public value: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = this.value !== null ? builder.createString(this.value!) : 0;

    return XmlElement.createXmlElement(builder, value);
  }

  clone(): XmlElementT {
    const obj = new XmlElementT();
    obj.value = this.value;
    return obj;
  }

  equals(other: XmlElementT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyXmlElement(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "value");
  } finally {
    verifier.popDepth();
  }
}
